import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser';

export default class CircleButton extends Phaser.GameObjects.Container {
  constructor(scene, cont, lblSprite, { scale, bottomLblSprite } = {}) {
    super(scene);
    cont ? cont.add(this) : scene.add.existing(this);

    this.scene = scene;
    this.cont = cont;
    this.lblSprite = lblSprite;
    this.bottomLblSprite = bottomLblSprite;
    this.txtString = '';

    let size = 24;
    if (this.lblSprite === 'LblEasy') this.txtString = ABCyaPhaser.Localization.instance.getLocalizedString('buttons.easy');
    if (this.lblSprite === 'LblMedium') {
      this.txtString = ABCyaPhaser.Localization.instance.getLocalizedString('buttons.medium');
    }
    if (this.lblSprite === 'LblHard') this.txtString = ABCyaPhaser.Localization.instance.getLocalizedString('buttons.hard');
    if (this.lblSprite === 'BtnLblMixed') {
      this.txtString = ABCyaPhaser.Localization.instance.getLocalizedString('buttons.all');
      size = 36;
    }

    this.bg = ABCyaPhaser.Images.addImage(0, 0, 'CircleButton', this);
    if (scale) {
      this.bg.setScale(scale);
    }

    if (this.lblSprite === 'BtnLblWholeNumbers' || this.lblSprite === 'BtnLblFractions' || this.lblSprite === 'BtnLblDecimals') this.lbl = ABCyaPhaser.Images.addImage(0, 0, this.lblSprite, this);
    this.txt = this.scene.add.bitmapText(0, 0, 'asapReg', this.txtString, size).setTintFill('0xFFFFFF')
      .setOrigin(.5);
    this.add(this.txt);

    if (this.bottomLblSprite) {
      let txt = '';
      if (this.bottomLblSprite === 'LblWholeNumbers') txt = ABCyaPhaser.Localization.instance.getLocalizedString('select.button_1');
      if (this.bottomLblSprite === 'LblFractions') txt = ABCyaPhaser.Localization.instance.getLocalizedString('select.button_2');
      if (this.bottomLblSprite === 'LblDecimals') txt = ABCyaPhaser.Localization.instance.getLocalizedString('select.button_3');
      if (this.bottomLblSprite === 'LblMixed') txt = ABCyaPhaser.Localization.instance.getLocalizedString('select.button_4');

      this.txt = this.scene.add.bitmapText(0, this.bg.getBounds().height - 16, 'asapReg', txt, 24).setOrigin(.5);
      this.add(this.txt);
    }

    this.setSize(this.getBounds().width, this.getBounds().height);
    this.setInteractive({ useHandCursor: true });
  }

  select() {
    this.bg.setTexture(ABCyaPhaser.Images.DEFAULT_ATLAS, 'CircleButton_Selected');
    this.moveBelow(this.bg, this.txt);
  };

  unselect() {
    this.bg.setTexture(ABCyaPhaser.Images.DEFAULT_ATLAS, 'CircleButton');
    this.moveBelow(this.bg, this.txt);
  };
}